import { Component, OnInit } from '@angular/core';
import {ExperiencedayService, experiencedayStatuses} from '../../shared/services/experienceday.service';

@Component({
    selector: 'app-student-experiencedays',
    templateUrl: './student-experiencedays.component.html',
    styleUrls: ['./student-experiencedays.component.scss'],
    standalone: false
})
export class StudentExperiencedaysComponent implements OnInit {

  view = {
    filters: {
      pageNumber: 1,
      pageSize: 100
    },
      data: []
  }

  constructor(public experiencedayService: ExperiencedayService) {



  }

  ngOnInit(): void {

    this.getData();

  }

  getData()
  {

    this.experiencedayService.apiGetExperiencedays().subscribe( (response: any) => {

      if (response && response.hasOwnProperty('data')) {
        this.view.data = Object.assign([], response.data)
      }

    });

  }


}
